export enum EView {
    StoreList,
    Appointment,
}
